module.exports = "https://dev.stanwinstonschool.com/2-history-mobile.a1c9e8fa9ec14596e10a764aaa56e118.jpg";